import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import Stats from './Stats';

//styles
import { ProfileStatsContainer, AvatarContainer, StatsContainer, UserNameContainer } from './style';

//components
import { ProfileAvatar } from '../../Components/ProfileAvatar/ProfileAvatar';

//layouts
import { config } from '../../../Configurations';

const ProfileStats = ({ fullName, image }) => {
    return (
        <ProfileStatsContainer>
            <AvatarContainer>
                <ProfileAvatar size={'large'} src={`${config.baseUrl}/${image}`} />
            </AvatarContainer>
            <StatsContainer>
                <UserNameContainer>{fullName}</UserNameContainer>
                <Stats />
            </StatsContainer>
        </ProfileStatsContainer>
    );
};

const mapStateToProfileProps = ({ profile: { currentProfile } }) => {
    return {
        fullName: currentProfile.fullName,
        type: currentProfile.type,
        image: currentProfile.mediumImage,
    };
};

ProfileStats.defaultProps = {
    image: '',
};

export default compose(
    withRouter,
    connect(mapStateToProfileProps),
)(ProfileStats);



// WEBPACK FOOTER //
// ./src/UI/Containers/ProfileStats/ProfileStats.js